import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { PooCommentsTemplate } from './variants/PooComments'

const pooCommentsVariant = {
  ...productRowVariantForPath('poo', 2),
  Template: PooCommentsTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('poo')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [pooCommentsVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [pooCommentsVariant],
    fallback: productRows.submsges.fallback,
  },
})
